import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaUnknownDefinition } from './TypedDefinition'

export const SchemaUnknownPlugin = createSchemaPlugin(
  'Schema.Unknown',
  SchemaUnknownDefinition
)
